import { Flower2, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { openChat } from "../../lib/api";
import { useContent, pick } from "../../lib/content";

const cards = [
  ["Offrande d'amour", "Bougies, fleurs blanches et eau claire : nourrir le lien retrouvé et adoucir les cœurs."],
  ["Offrande de travail", "Lumière et symboles de réussite : ouvrir les portes, fléchir les supérieurs, attirer la faveur."],
  ["Offrande de chance", "Gestes simples et générosité partagée : maintenir la chance allumée autour de vous."],
];

export const Offerings = () => {
  const c = useContent();
  return (
  <section id="offrandes" className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-36" data-testid="offerings-section">
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal><Eyebrow>Offrandes &amp; conseils</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl leading-tight text-amber-50 sm:text-4xl lg:text-5xl">
            Améliorer votre situation
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-stone-300 md:text-lg whitespace-pre-line">
            {pick(c, "offerings_intro",
              "Après chaque travail, le Maître Wouffa vous indique une offrande simple et accessible — lumière, fleurs, eau, geste de partage — qui entretient la force du rituel et élève votre situation jour après jour.")}
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button onClick={() => openChat("Bonjour Maître, quelle offrande conseillez-vous pour améliorer ma situation ? Ma situation est : ")}
            data-testid="offerings-chat-button"
            className="mt-10 flex items-center gap-3 rounded-full bg-amber-400 px-7 py-3.5 text-sm font-bold uppercase tracking-[0.15em] text-stone-950 transition-transform duration-300 hover:scale-[1.03] active:scale-95">
            <MessageCircle className="h-4 w-4" /> Demander mon offrande
          </button>
        </Reveal>
      </div>
      <div className="flex flex-col gap-4 lg:col-span-6 lg:col-start-7">
        {cards.map(([title, txt], i) => (
          <Reveal key={title} delay={0.1 * i}>
            <div className="flex items-start gap-5 rounded-2xl border border-amber-900/40 bg-[#181512] p-6 md:p-8" data-testid={`offering-${i}`}>
              <Flower2 className="mt-1 h-5 w-5 shrink-0 text-amber-400" />
              <div>
                <p className="font-serif-it text-2xl italic text-amber-100">{title}</p>
                <p className="mt-2 text-sm leading-relaxed text-stone-300">{txt}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
